// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","number":"number-WiVrC","header":"header-1Ll7e","passenger":"passenger-31n8V","passenger_filled":"passenger_filled-gX7sc"};